module.exports = __webpack_public_path__ + "static/img/wap_foot_bg.0cc822f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wap_foot_bg.png
// module id = XhZC
// module chunks = 17